import { render, staticRenderFns } from "./edit-product.vue?vue&type=template&id=1fb23b33&"
import script from "./edit-product.vue?vue&type=script&lang=ts&"
export * from "./edit-product.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports